module.exports = __webpack_public_path__ + "static/media/petlee-1.9b49a987.png";